import React, { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";
import { BASE_PATH_API, PATH_FILE_UPLOAD } from "../../utils/Constants";

export default function UploadFile(props: any) {
  const toast = useRef<Toast>(null);
  const [totalSize, setTotalSize] = useState(0);
  const fileUploadRef = useRef<FileUpload>(null);

  const onTemplateSelect = (e: any) => {
    // For single file, just get the size of the first file selected
    //setTotalSize(e.files[0]?.size || 0);

    let _totalSize = totalSize;
    let files = e.files;

    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0;
    });

    setTotalSize(_totalSize);
  };

  const typeDoc =
    props.typeDoc === "nvasolicitudes" ? "solicitudes" : props.typeDoc;

  const onTemplateUpload = (e: any) => {
    setTotalSize(0);

    let _totalSize = 0;

    e.files.forEach((file: any) => {
      _totalSize += file.size || 0;
    });

    if (fileUploadRef.current) {
      fileUploadRef.current.clear();
    }

    if (toast.current) {
      setTotalSize(_totalSize);
      toast.current.show({
        severity: "info",
        summary: "Success",
        detail: "File Uploaded",
      });
      /*toast.current.show({
        severity: "info",
        summary: "Éxito",
        detail: "Archivo subido exitosamente",
      });*/
    }

    props.setDialogVisible(false);
    if (props.typeDoc === "nvasolicitudes") {
      props.setGoHome(true);
    }
  };

  const onTemplateRemove = (file: any, callback: () => void) => {
    //setTotalSize(0); // Reset total size since there's only one file
    setTotalSize(totalSize - file.size);
    callback();
  };

  const onTemplateClear = () => {
    setTotalSize(0);
  };

  const onError = (event: any) => {
    const errorNumber = event.xhr.status;

    setTotalSize(0);
    if (toast.current) {
      if (errorNumber === 400) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "El formato del archivo no es válido",
        });
      }

      if (errorNumber === 500) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al subir el archivo",
        });
      }
    }
  };

  const headerTemplate = (options: {
    className: any;
    chooseButton: any;
    uploadButton: any;
    cancelButton: any;
  }) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 100000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : "0 B";

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
        {cancelButton}
        <div className="flex align-items-center gap-3 ml-auto">
          <span>{formatedValue} / 10 MB</span>
          <ProgressBar
            value={value}
            showValue={false}
            style={{ width: "10rem", height: "12px" }}
          ></ProgressBar>
        </div>

        <div style={{ width: "100%" }}>
          <div style={{ textAlign: "left" }}>
            <p>
              Se aceptan sólo archivos de los siguientes formatos: .jpeg, .png,
              .pdf, .xls, .xlsx, .doc, .docx, .ppt, .pptx
            </p>
            <div style={{ textAlign: "right" }}>{uploadButton}</div>
          </div>
        </div>
      </div>
    );
  };

  /*const itemTemplate = (
    file: any,
    options: {
      formatSize: string;
      onRemove: (event: React.SyntheticEvent) => void;
    }
  ) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small style={{ paddingLeft: "10px", paddingRight: "10px" }}>
              {new Date().toLocaleDateString()}
            </small>
          </span>
          <Tag
            value={options.formatSize}
            severity="warning"
            className="px-3 py-2"
          />
        </div>

        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={(event) =>
            onTemplateRemove(file, () => options.onRemove(event))
          }
        />
      </div>
    );
  };*/

  const itemTemplate = (file: any, props: any) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>
        <Tag
          value={props.formatSize}
          severity="warning"
          className="px-3 py-2"
        />
        <Button
          style={{ marginLeft: "20px", width: "30px", height: "30px" }}
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };

  const emptyTemplate = () => {
    return (
      <div
        style={{ textAlign: "center" }}
        className="flex align-items-center flex-column"
      >
        <i
          className="pi pi-image mt-3 p-5"
          style={{
            fontSize: "5em",
            borderRadius: "50%",
            backgroundColor: "var(--surface-b)",
            color: "var(--surface-d)",
          }}
        ></i>

        <div>
          <span
            style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
            className="my-5"
          >
            Arrastra tu archivo aquí
          </span>
        </div>
      </div>
    );
  };

  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };
  const uploadOptions = {
    icon: "pi pi-fw pi-cloud-upload",
    label: "SUBIR ARCHIVO",
    className:
      "custom-upload-btn p-button-success p-button-rounded p-button-outlined",
    style: {
      padding: "0.5vw",
      backgroundColor: totalSize > 0 ? "green" : "grey",
    },
  };
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  };

  return (
    <div>
      <Toast ref={toast}></Toast>
      <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
      <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
      <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

      <FileUpload
        ref={fileUploadRef}
        name="file"
        url={`${BASE_PATH_API}${PATH_FILE_UPLOAD}?ano=${props.ano}&mes=${props.mes}&typeDoc=${typeDoc}&id=${props.id}`}
        accept="*/*"
        maxFileSize={10000000}
        onUpload={onTemplateUpload}
        onSelect={onTemplateSelect}
        onError={(e) => onError(e)}
        onClear={onTemplateClear}
        headerTemplate={headerTemplate}
        itemTemplate={itemTemplate}
        emptyTemplate={emptyTemplate}
        chooseOptions={chooseOptions}
        uploadOptions={uploadOptions}
        cancelOptions={cancelOptions}
      />
    </div>
  );
}

/*import React, { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";
import { BASE_PATH_API, PATH_FILE_UPLOAD } from "../../utils/Constants";

export default function UploadFile(props: any) {
  const toast = useRef<Toast>(null);
  const [totalSize, setTotalSize] = useState(0);
  const fileUploadRef = useRef<FileUpload>(null);
  const [showDialog, setShowDialog] = useState(true);

  console.log("PROPS en upload file: ", props);
  const onTemplateSelect = (e: any) => {
    let _totalSize = totalSize;
    let files = e.files;

    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0;
    });

    setTotalSize(_totalSize);
  };

  const onTemplateUpload = (e: any) => {
    let _totalSize = 0;

    e.files.forEach((file: any) => {
      _totalSize += file.size || 0;
    });

    setTotalSize(_totalSize);
    if (toast.current) {
      toast.current.show({
        severity: "info",
        summary: "Success",
        detail: "Archivo subido exitosamente",
      });
    }

    props.setDialogVisible(false);
  };

  const onTemplateRemove = (file: any, callback: () => void) => {
    console.log("HOLA");
    setTotalSize(totalSize - file.size);
    callback();
  };

  const onTemplateClear = () => {
    console.log("HOLA");
    setTotalSize(0);
  };

  const onError = (event: any) => {
    const errorNumber = event.xhr.status;

    setTotalSize(0);
    if (toast.current) {
      if (errorNumber === 400) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "El formato del archivo no es válido",
        });
      }

      if (errorNumber === 500) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al subir el archivo",
        });
      }
    }
  };

  const headerTemplate = (options: {
    className: any;
    chooseButton: any;
    uploadButton: any;
    cancelButton: any;
  }) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 100000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : "0 B";

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
        {cancelButton}
        <div className="flex align-items-center gap-3 ml-auto">
          <span>{formatedValue} / 10 MB</span>
          <ProgressBar
            value={value}
            showValue={false}
            style={{ width: "10rem", height: "12px" }}
          ></ProgressBar>
        </div>

        <div style={{ width: "100%", textAlign: "right" }}>{uploadButton}</div>
      </div>
    );
  };

  const itemTemplate = (
    file: any,
    options: {
      formatSize: string;
      onRemove: (event: React.SyntheticEvent) => void;
    }
  ) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small style={{ paddingLeft: "10px", paddingRight: "10px" }}>
              {new Date().toLocaleDateString()}
            </small>
          </span>
          <Tag
            value={options.formatSize}
            severity="warning"
            className="px-3 py-2"
          />
        </div>

        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={(event) =>
            onTemplateRemove(file, () => options.onRemove(event))
          }
        />
      </div>
    );
  };

  const emptyTemplate = () => {
    return (
      <div
        style={{ textAlign: "center" }}
        className="flex align-items-center flex-column"
      >
        <i
          className="pi pi-image mt-3 p-5"
          style={{
            fontSize: "5em",
            borderRadius: "50%",
            backgroundColor: "var(--surface-b)",
            color: "var(--surface-d)",
          }}
        ></i>

        <div>
          {" "}
          <span
            style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
            className="my-5"
          >
            Arrastra tus archivos aquí
          </span>
        </div>
      </div>
    );
  };

  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };
  const uploadOptions = {
    icon: "pi pi-fw pi-cloud-upload",
    iconOnly: true,
    className:
      "custom-upload-btn p-button-success p-button-rounded p-button-outlined",
  };
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  };

  //EL FOLDER DESTINO DEBE SER
  return (
    <div>
      <Toast ref={toast}></Toast>
      <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
      <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
      <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

      <FileUpload
        ref={fileUploadRef}
        name="file"
        url={`${BASE_PATH_API}${PATH_FILE_UPLOAD}?ano=${props.ano}&mes=${props.mes}&typeDoc=${props.typeDoc}&id=${props.id}`}
        accept="*\/*"
        maxFileSize={10000000}
        onUpload={onTemplateUpload}
        onSelect={onTemplateSelect}
        onError={(e) => onError(e)}
        onClear={onTemplateClear}
        headerTemplate={headerTemplate}
        itemTemplate={itemTemplate}
        emptyTemplate={emptyTemplate}
        chooseOptions={chooseOptions}
        uploadOptions={uploadOptions}
        cancelOptions={cancelOptions}
      />
    </div>
  );
}*/
